<template>
  <v-layout class="booking-status">
    <v-icon size="16" class="status-colors" :class="statusColor">{{statusIcon}}</v-icon>
    <span :class="`status-text status-colors ${statusColor}`">{{$t(`booking.status.${statusKey}`)}}</span>
  </v-layout>
</template>

<script>
  import {BOOKING_STATUSES} from "@/modules/common/constants/bookingStatus";

  export default {
    name: "BookingStatus",
    props: {
      rsvpState: {
        type: String,
        default: ''
      },
      status: {
        type: String,
        required: true,
        // completed
        // done
        // invited
        // pending_reschedule
        // request_expired
        // scheduled
        // proposed_time = proposed
        // rejected = declined
        // requested = pending_approval
        // reschedule

        // cancelled - ?
        // created - ?

        // ? - confirmed
        validator: prop => BOOKING_STATUSES.includes(prop.toLowerCase()),
      },
      noShow: {
        type: Boolean,
        default: false,
      },
      colorClass: {
        type: String,
        required: false,
      }
    },
    computed: {
      statusKey() {
        if (this.noShow) {
          return 'no_show'
        }
        if(this.status === 'confirmed') {
          return this.rsvpState === 'confirmed' ? 'confirmed' : 'registered'
        }
        return this.status
      },
      statusColor() {
        if (this.colorClass) return this.colorClass
        if (this.noShow) return 'status-red'

        switch (this.status) {
          case 'scheduled':
          case 'confirmed':
            return 'status-green';
          case 'request_expired':
          case 'rejected':
          case 'done':
          case 'completed':
          case 'cancelled':
            return 'status-black';
          case 'reschedule':
          case 'requested':
          case 'proposed_time':
          case 'pending_reschedule':
          case 'invited':
            return 'status-grey';
          case 'pending':
            return 'status-yellow'
        }
      },
      statusIcon() {
        if (this.noShow) return 'icon-eye-hide-s'

        switch (this.status) {
          case 'scheduled':
            return 'icon-Scheduled';
          case 'request_expired':
            return 'icon-rejected';
          case 'rejected':
          case 'cancelled':
            return 'icon-Decline1';
          case 'done':
          case 'completed':
            return 'icon-Completed';
          case 'reschedule':
          case 'requested':
            return 'icon-pending';
          case 'invited':
          case 'proposed_time':
          case 'pending':
            return 'icon-Time';
          case 'pending_reschedule':
            return 'icon-expired';
          case 'confirmed':
            return 'icon-confirmed';
        }
      },
    }
  };
</script>

<style lang="scss" scoped>

  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .booking-status {
    flex-grow: 0;
    .status-text {
      font-family: var(--primary-font-family);
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.2px;
      @include i-margin-mirror(4px, 0);

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>
